import { render, staticRenderFns } from "./V2TablePage.vue?vue&type=template&id=5ee68860&scoped=true"
import script from "./V2TablePage.vue?vue&type=script&lang=js"
export * from "./V2TablePage.vue?vue&type=script&lang=js"
import style0 from "./V2TablePage.vue?vue&type=style&index=0&id=5ee68860&prod&lang=scss&scoped=true"
import style1 from "./V2TablePage.vue?vue&type=style&index=1&id=5ee68860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee68860",
  null
  
)

export default component.exports